import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import "./paymentOption.css"
import CustomTittle from '../../../../components/Elements/customTittle/customTittle';
import CustomButtons from '../../../../components/Elements/Buttons/customButton';



 
const PaymentOption = (props) => {
    let isRaty = false;
    let isCamp = false;
    let isbillet = false;

    let raty = props.payment.paymentShedule;
    let lowestRata = raty[0]?.paymentPositionPrice;
    if(props.isCamp){
        isCamp = true;
    } 
    console.log(props.payment.numberOfLessons)
    if(props.isbillet){
        console.log(isbillet)
        isbillet = true;
        console.log(isbillet)

    } 
    if(props.isRaty){
        isRaty = true;  
        lowestRata = raty[0].paymentPositionPrice
         


    }      

    return <> 
   {isCamp? 
   <div className='paymentOption'>
   <CustomTittle>{props.title}</CustomTittle>
   <label className='paymentPrice'><p>Cena:</p> {props.price.toString().replace(".",",") + " zł"}</label>
   
   {isRaty?
    <label className='paymentMounth'> {lowestRata + "zł / pierwsza rata"}<p className='hintTextDot' title={props.labelCamp}>?</p></label>:""}
   <label className='paymentPrice'><p>{props.labelCamp}</p></label>
   <CustomButtons clickFunction={()=>{props.next(props.payment)}} size="big" classButton="solid" >WYBIERZ</CustomButtons>
   </div>
   :<div className='paymentOption'>
    <CustomTittle>{props.title}</CustomTittle>
    <label className='paymentPrice'><p>Cena:</p> {props.price.toString().replace(".",",") + " zł"}</label>
    {props.oneMounth.toString().includes(".")||props.oneMounth.toString().includes(",")?<p className='paymentMounth'>{props.oneMounth.toString().replace(".",",") + " " + props.duration}</p>:<p className='paymentMounth'>{props.oneMounth + ",00 " + props.duration}</p>}
    {!isbillet?<label className='entryFee'>Opłata wpisowa:<p className='entryFee_value'>{props.entry.toString().replace(".",",") + " zł"}</p> <p className='hintTextDot' title='Opłata wpisowa dla nowych uczestników zajęć w Egurrola Dance Studio jest jednorazowa, bezzwrotna i wynosi 99 zł. W ramach opłaty otrzymasz od nas kartę członkowską i wyjątkowy Pakiet Startowy, w którym znajdziesz nasze gadżety'>?</p></label>:''}
    {isbillet?<label className='entryFee'>Liczba wejść:<p className='entryFee_value'>{props.payment.numberOfLessons}</p> <p className='hintTextDot' title='Opłata wpisowa dla nowych uczestników zajęć w Egurrola Dance Studio jest jednorazowa, bezzwrotna i wynosi 99 zł. W ramach opłaty otrzymasz od nas kartę członkowską i wyjątkowy Pakiet Startowy, w którym znajdziesz nasze gadżety'>?</p></label>:''}

    <CustomButtons clickFunction={()=>{props.next(props.payment.productsID, props.payment.paymentTypesDVID, props.payment)}} size="big" classButton="solid" >WYBIERZ</CustomButtons>
    </div>}
    </>;
    }

export default PaymentOption;
